import React from 'react';
import BaseModal, {
	BaseModalProps,
} from '../../../Base/Components/BaseModal/BaseModal';
import UserSettingsProfile from './UserSettingsProfile';
import { Size } from '../../../../Enums/Size.enum';

interface Props extends BaseModalProps {
	userId: string;
}

const UserSettingsProfileModal: React.FC<Props> = props => (
	<BaseModal title='base.shared.myProfile' {...props} size={Size.SM}>
		<UserSettingsProfile userId={props.userId} onSuccess={props.onClose} />
	</BaseModal>
);

export default UserSettingsProfileModal;
